<template>
  <v-card rounded="xl" outlined>
    <v-card-title>
      <v-row no-gutters>
        <v-col cols="12">
          <v-chip class="primary--text" color="#F0F6FA">Psicossocial</v-chip>
        </v-col>
        <v-col class="mt-3 pb-2 mapeamento-card__border-dotted">
          <h5>{{ mapeamento.nome }}</h5>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text class="pb-1">
      <p v-if="mapeamento.dtInicio">
        <v-icon class="mr-1" size="20" color="primary">mdi-calendar-start</v-icon>
        <strong>Início:</strong> {{ formatarData(mapeamento.dtInicio) }}
      </p>
      <p v-if="mapeamento.dtFinal">
        <v-icon class="mr-1" size="20" color="primary">mdi-calendar-end</v-icon>
        <strong>Encerramento:</strong> {{ formatarData(mapeamento.dtFinal) }}
      </p>
      <div class="mapeamento-card__border-dotted mt-3"></div>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-row no-gutters align="center" justify="space-between">
        <div>
          <v-chip
            v-if="finalizado"
            x-small
            outlined
            color="primary"
            class="font-weight-medium mr-2"
          >
            Finalizado
          </v-chip>
          <v-chip
            x-small
            :color="mapeamento.preenchido ? 'success' : 'warning'"
            text-color="white"
            class="font-weight-medium"
          >
            {{ mapeamento.preenchido ? 'Preenchido' : 'Não Preenchido' }}
          </v-chip>
        </div>
        <div>
          <v-btn
            v-if="mapeamento.preenchido"
            small
            rounded
            text
            color="primary"
            class="secondary-font text-capitalize font-weight-bold"
            @click="$emit('ver-respostas')"
          >
            Ver Respostas
          </v-btn>
          <v-btn
            v-if="!finalizado && !mapeamento.preenchido"
            small
            rounded
            color="primary"
            class="secondary-font text-capitalize font-weight-bold"
            @click="$emit('preencher')"
          >
            Preencher
          </v-btn>
        </div>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { format, parseISO } from 'date-fns'

export default {
  name: 'MapeamentoCard',
  props: {
    mapeamento: {
      required: true,
      type: Object
    },
    finalizado: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatarData(data) {
      return format(parseISO(data), 'dd/MM/yyyy')
    }
  }
}
</script>

<style scoped>
.mapeamento-card__border-dotted {
  border-bottom: 1px dashed #e0e0e0;
}
</style>
